<template>
  <Loader v-if="loading" />
  <div v-else>
    <BaseFormGroup>
      <BaseFormLabel :for="`${_uid}-pipeline_id`"> Pipeline * </BaseFormLabel>

      <BaseFormSelect
        :value="data.pipeline_id"
        :options="options"
        :id="`${_uid}-pipeline_id`"
        @input="setProps"
      />
    </BaseFormGroup>
  </div>
</template>

<script>
import { projectPipelinesClient } from '@/api/clients';

export default {
  props: {
    projectUuid: { type: String, required: true },
    defaultData: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      loading: false,
      options: [],
      data: {
        pipeline_id: null,
        ...this.defaultData,
      },
    };
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      this.loading = true;

      try {
        const { data = {} } = await projectPipelinesClient.list(this.projectUuid);

        if (data && data.data) {
          this.options = data.data.map(({ id, name }) => ({ label: name, value: id }));
        }
      } catch (error) {
        //
      }

      this.loading = false;
    },

    setProps(pipelineId) {
      if (!pipelineId) this.$emit('update-props', null);

      this.$emit('update-props', { pipeline_id: pipelineId });
    },
  },
};
</script>
